import React from "react";
import {MutateCalendarEventRequest, IKensuCalendarEventProto, KensuCalendarEventProto} from "../../../../provider_api";
import './Calendar.css';
import {EventModal} from "./EventModal";
import {useMutateCalendarEvent} from "../../../../util/RpcHooks/MutateCalendarEvent";
import {getEventType} from "./CalendarUtil";

type Props = {

  // These come from the dragged calendar
  startTime: Date,
  endTime: Date,

  // The range of the current calendar view, this is used to request all
  // the instances of the newly created event. 
  calendarViewStart: Date,
  calendarViewEnd: Date,

  onCreate: (event: IKensuCalendarEventProto[]) => void,
  onCancel: () => void,
}

export const NewEventModal = (props: Props) => {

  const mutateEventRpc = useMutateCalendarEvent();

  const sendCreateRpc = (event: IKensuCalendarEventProto) => {
    const eventType = getEventType(event);
    console.log('sending rpc', eventType, event)

    if (!eventType) {
      // This is the only "pre-rpc sending error"
      mutateEventRpc.setErrors([{path: 'eventType', error: 'Please choose a type'}])
      return;
    }

    console.log('sending rpc')

    mutateEventRpc.send({
      method: "create_" + eventType,
      request: new MutateCalendarEventRequest({
        event: event,
        clientStartTimestampMs: props.calendarViewStart.getTime(),
        clientEndTimestampMs: props.calendarViewEnd.getTime(),
      }),
      onSuccess: (instances) => props.onCreate(instances)
    });
  }

  return <EventModal

      // This is the 'default' blank event
      classBookings={[]}
      onClassBookingDeleted={() => {}} // no bookings to delete on new events
      instance={new KensuCalendarEventProto({
        timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
        startTimestamp: props.startTime.getTime(),
        endTimestamp: props.endTime.getTime(),
      })}
      errors={mutateEventRpc.errors}
      mutateRpcState={mutateEventRpc.rpcState}
      mode={'create'}
      onSave={sendCreateRpc}
      onDelete={() => { /* no deleting here */
      }}
      onCancel={props.onCancel}
  />
};
